<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">登録内容の変更に関して</h5>
                    <HelpMenuItem menuTitle="Q．会員情報を変更したいです。" menuId="1">
                        1. マイページにログインします。<br>
                        2. 画面右上のMENUをクリックし、サイドメニューを開きます。<br>
                        3. 「会員情報」をクリックし、「会員情報の参照・変更」をクリックします。<br>
                        4. 生年月日横の「変更」ボタンをクリックします。<br>
                        5. 変更内容入力し、変更をクリックして終了です。<br>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．メールアドレスを変更したいです。" menuId="2">
                        登録情報変更の手順は以下の通りです。<br>
                        1. マイページにログインします。<br>
                        2. サイドメニューから「会員情報の参照・変更」をクリックします。<br>
                        3. 画面下の「会員情報の変更」をクリック。<br>
                        4. メールアドレスとメールアドレス（確認）に変更したいメールアドレスを入力。<br>
                        ※メールアドレスとメールアドレス（確認）には同じメールアドレスを入力してください。<br>
                        5. 「会員情報を変更」をクリック。<br>
                        6. 会員情報変更メール送信完了画面に移動します。同時に、変更したメールアドレスに「メールアドレス変更」メールが届きます。<br>
                        7. 「メールアドレス変更」メールのリンクをクリックし、登録完了画面に移動すると完了になります。<br>
                        入力したメールアドレスに確認メールを送信し、確認メールに記載された所定のURLにアクセスすることで<br>
                        メール配信の環境・アドレスが適切か否かを判断しています。<br>
                        8. 完了です。<br><br>
                        【注意点】 <br>
                        ・この手順では、メールアドレスの変更のみ可能です。 <br>
                        ・メールが届かない場合は、迷惑メールフォルダに入っていないかご確認ください。<br>
                        ・受信できない場合、ドメインを受信許可してください。<br>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．パスワードを変更したいです。" menuId="3">
                        パスワード変更手順は以下の通りです。 <br>
                        1. マイページにログインします。 <br>
                        2. サイドメニューから「会員情報の参照・変更」をクリックします。<br>
                        3. 「パスワード変更」をクリック。<br>
                        4. 現在のパスワードに使用しているパスワードを入力。<br>
                        5. 新しいパスワードと新しいパスワード（確認）に変更したいパスワードを入力して下さい。<br>
                        ※パスワードとパスワード（確認）には同じパスワードを入力してください。 <br>
                        6. パスワード変更完了画面に移動します。<br>
                        7. 完了です。<br>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．各種メールが届きません。" menuId="4">
                        <p>・ドメイン指定受信を設定してください。<br><br>
                        ・迷惑メールブロック設定＞URLリンク付きメール拒否設定を<br>
                        【受信する／特定URLを含むメールのみ受信しない】のいずれかに変更してください。<br><br>
                        上記内容をご確認の上、改善されない場合、お手数ですが下記宛に<br>
                        お問い合わせください。
                        </p>
                        <a :href="`mailto:${info_mail}`">{{ info_mail }}</a>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．退会したいです。" menuId="5">
                        退会手順は以下の通りです。<br>
                        1. マイページにログインします。 <br>
                        2. サイドメニューから「会員情報の参照・変更」をクリックします。<br>
                        3. 「会員を退会する」をクリック。<br>
                        4. アンケートをご回答の上、「会員を退会する」をクリック。<br>
                        5. 会員退会完了画面に移動します。<br>
                        6. 完了です。<br><br>
                        【注意点】<br>
                        登録解除後に再度ご利用頂く場合は、新規ユーザー登録して頂く必要があります。再登録時は過去の利用情報は引き継がれません。<br>
                    </HelpMenuItem>
                </div>
            </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
        </div>
    </div>
</div>
</template>


<script>
import HelppageSideMenu from './HelppageSideMenu';
import HelpMenuItem from './components/HelpMenuItem';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
    }
}
</script>